export const injectVariable = (prompt: string, variables: { [key: string]: string | undefined }): string => {
  let newPrompt = prompt;

  Object.keys(variables).forEach(variable => {
    if (variables[variable]) {
      newPrompt = newPrompt.replaceAll(`{${variable}}`, `{${variables[variable]}}`);
    }
  });

  return newPrompt;
};
